import { TOGGLE_PROJECT_STATE } from '../../mutation-types';
import { MOBILE_SWITCHER_STATES, OVERLAY_CONFIGS } from './helpers';

/**
 * Toggle a single overlay
 * @param {function} commit - Vuex method
 * @param {function} dispatch - Vuex method
 * @param {string} id - The state id
 * @param {string} mutation - The mutation string
 * @param {any} mutationConfig - The overlay config
 * @param {boolean} value - The state flag
 */
function toggleOverlay({ commit, dispatch }, { id, mutation, mutationConfig, value }) {
    commit(TOGGLE_PROJECT_STATE, { id, value });
    dispatch(`vue-ui/overlay/${ mutation }Overlay`, mutationConfig, { root: true }).catch(error => {
        throw error;
    });
}

/**
 * Toggle mobile switcher position
 */
export function toggleMobileSwitcher({ commit }, { position }) {
    commit(TOGGLE_PROJECT_STATE, { id: 'mobileSwitcher', value: position });
}

/**
 * Toggle gallery overlay
 */
export function toggleGalleryOverlay({ commit, dispatch }, { imageIdx, images, open }) {
    const overlayConfigName = 'galleryOverlay';
    toggleOverlay({ commit, dispatch }, {
        id: overlayConfigName,
        mutation: open ? 'open' : 'close',
        mutationConfig: OVERLAY_CONFIGS[overlayConfigName]({ imageIdx, images, open }),
        value: open,
    });
}

/**
 * Toggle home overlay
 */
export function toggleHomeOverlay({ commit, dispatch }, { animate, open }) {
    const overlayConfigName = 'homeOverlay';

    dispatch('toggleMobileSwitcher', { position: MOBILE_SWITCHER_STATES.LIST });
    toggleOverlay({ commit, dispatch }, {
        id: overlayConfigName,
        mutation: open ? 'open' : 'close',
        mutationConfig: OVERLAY_CONFIGS[overlayConfigName]({ animate, open }),
        value: open,
    });
}

/**
 * Toggle visibility of the menu sidebar
 */
export function toggleMenuSidebar({ commit, dispatch }, { open }) {
    const overlayConfigName = 'menuSidebar';

    toggleOverlay({ commit, dispatch }, {
        id: overlayConfigName,
        mutation: open ? 'open' : 'close',
        mutationConfig: OVERLAY_CONFIGS[overlayConfigName]({ open }),
        value: open,
    });
}
